import { render, staticRenderFns } from "./ListagemFotosSig.vue?vue&type=template&id=e2ce0c54&scoped=true&"
import script from "./ListagemFotosSig.vue?vue&type=script&lang=js&"
export * from "./ListagemFotosSig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ce0c54",
  null
  
)

export default component.exports